<div class="flex flex-col justify-center items-center">
  <div class="flex flex-col justify-center items-center text-center sm:text-lg font-semibold mt-10 sm:mt-36">
    <span>Wir bleiben gerne mit Ihnen in Kontakt und lernen Sie besser kennen.</span>
    <span>Bitte geben Sie uns hierfür Ihre Einwilligungen in wenigen Schritten.</span>
  </div>
  <button
    class="text-white text-sm rounded-full py-2 px-2 h-[40px] w-[150px] mt-10"
    [ngClass]="
    brand.isLexus()
    ? 'bg-lexusBlue hover:bg-lexusBlueDark'
    : 'bg-toyotaRed hover:bg-toyotaRedDark'
    "
    (click)="nextStep.emit()"
  >
    Start
  </button>
</div>
